<script setup>
import { onMounted } from 'vue';
import { RouterView, useRoute } from 'vue-router';

import { useCoverageOptionsVoordeelpakket } from '@/composables/useCoverageOptionsVoordeelpakket.js';
import loadFonts from '@/config/config.fontsLoader.js';
import { formStore } from '@/stores/form';
import { pakketStore } from '@/stores/pakket.js';
import { voertuigStore } from '@/stores/voertuig.js';

const route = useRoute();
const useFormStore = formStore();
const usevoertuigStore = voertuigStore();
const usePakketStore = pakketStore();

const { resetRoutes, updateRoutes, setRouteArray } = useCoverageOptionsVoordeelpakket();

onMounted(async () => {
  // eslint-disable-next-line no-undef
  const soort = funnelType ? funnelType : null;
  // eslint-disable-next-line no-undef
  const entry = funnelEntry ? funnelEntry : null;
  // eslint-disable-next-line no-undef
  const version = funnelVersion ? funnelVersion : 'dev-local';

  const ktv = {
    // eslint-disable-next-line no-undef
    aantal_beoordelingen: ktv_aantal_beoordelingen ? ktv_aantal_beoordelingen : 0,
    // eslint-disable-next-line no-undef
    rating: ktv_rating ? ktv_rating : 0,
    // eslint-disable-next-line no-undef
    percentage_aanbevelingen: ktv_percentage_aanbevelingen ? ktv_percentage_aanbevelingen : 0,
  };

  // set KTV (ratings)
  useFormStore.setKtv(ktv);

  // set funnelType
  useFormStore.setFunnelVersion(version);

  // set funnelType (used by the dev bar)
  const type = useFormStore.overruleFunnelType ?? soort;
  useFormStore.setFunnelType(type);

  useFormStore.setFunnelEntry(entry ? entry : soort);

  // set voertuig initial soort. only if there is no soort
  usevoertuigStore.setInitialSoort(soort);

  // set module
  usePakketStore.setInitialModule(soort);

  // Routes resetten op basis van funnelType (Als die wijzigt moet route wijzigen)
  await resetRoutes(soort);
  // Voor voordeelpakket direct op basis van gekozen verzekeringen routes updaten
  // Bij pagina refresh word anders de route gereset.
  if (soort === 'voordeelpakket') {
    await updateRoutes();
  }
  // Route array gebruiken om de volgende en vorige routes te kunnen bepalen
  await setRouteArray();

  useFormStore.setAlsGeenNeeBegonnen();

  // eslint-disable-next-line no-undef
  const selectedTenant = tenant ? tenant : 'default';

  // set the tenant.
  useFormStore.setTenant(selectedTenant === 'Alpina' ? 'default' : selectedTenant);

  // Load the font-faces dynamicly.
  await loadFonts();

  // Load the theme variables from tenant.
  await import(`@/styles/themes/${useFormStore.tenant}/colors.scss`);

  await useFormStore.initializeState();
});
</script>

<template>
  <component :is="route.meta.layout || 'div'">
    <RouterView />
  </component>
</template>
